import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GLOBALS } from "../Models/Globals";




export const usePagination = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const { t, i18n } = useTranslation();

    const GetPageCount = (items: number): number => {

        return Math.ceil(items / GLOBALS.MIN_TO_RENDER_PAGINATION);

    }

    const OnPageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
    };

    const GenPublishingDate = (docDate: string): string => {

        return t('label-publish-date') + `: ${moment(docDate).format(GLOBALS.DATE_FORMAT)}`

    };

    return [
        currentPage,
        OnPageChange,
        GetPageCount,
        GenPublishingDate
    ] as const;

};